import React from 'react';

export default function CheckIcon() {
  return (
    <svg width="16" height="12" viewBox="0 0 16 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M5.05161 11.2941C4.74048 11.2941 4.4366 11.1716 4.21758 10.9583L0.236706 7.07956C-0.0802264 6.76911 -0.078776 6.26649 0.240332 5.95887C0.55944 5.65124 1.07726 5.65265 1.3942 5.96168L5.05233 9.5272L14.6067 0.232216C14.9251 -0.0775226 15.4436 -0.0768187 15.7613 0.230808C16.079 0.539139 16.0797 1.04176 15.7628 1.3508L5.88637 10.9576C5.66879 11.1716 5.36419 11.2941 5.05161 11.2941Z" fill="#71CB9D" />
    </svg>
  );
}
